import { Calendar } from 'lucide-react';
import type { Product } from '@/services';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@lib/datetime';

interface ProductSeoCardProps {
  product: Product;
}

export function ProductSeoCard({ product }: ProductSeoCardProps) {
  const { t } = useTranslation();

  return (
    <div className="grid gap-6 md:grid-cols-2">
      <section>
        <h3 className="text-sm font-semibold text-foreground mb-1">{t('product.seo.preview')}</h3>
        <div className="space-y-1">
          {/* #1405: `seo_title` / `seo_description` / `body_html` are not on
              the `/api/products` wire (generated `Product`), so the former
              fallback chains always resolved to `title` / the no-description
              copy — rendered output is unchanged. */}
          <div className="text-sm font-medium text-accent truncate">{product.title}</div>
          <div className="text-xs text-success truncate">
            https://store.com/products/{product.handle}
          </div>
          <div className="text-sm text-muted-foreground line-clamp-2">
            {t('product.seo.noDescription')}
          </div>
        </div>
      </section>

      <section>
        <h3 className="text-sm font-semibold text-foreground mb-1">{t('product.seo.metadata')}</h3>
        <div className="divide-y divide-border/50">
          <div className="flex justify-between py-2">
            <span className="text-muted-foreground flex items-center gap-2 text-sm">
              <Calendar className="h-4 w-4" /> {t('product.seo.created')}
            </span>
            <span className="text-sm">{formatDate(product.created_at)}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-muted-foreground flex items-center gap-2 text-sm">
              <Calendar className="h-4 w-4" /> {t('product.seo.updated')}
            </span>
            <span className="text-sm">{formatDate(product.updated_at)}</span>
          </div>
        </div>
      </section>
    </div>
  );
}
